export const resolutions = {
  'team_avatar': ['86x86', '128x128', '162x162', '207x207'],
  'host_avatar': ['162x162'],
  'avatar': ['22x22', '86x86', '128x128', '162x162'],
  'banner': ['397x177', '1440x414'],
  'slider': ['240x150', '800x500', '1600x1000'],
  'armory_firm': null,
  'armory_category': null,
  'camouflage': ['128x128']
};